module.exports = __webpack_public_path__ + "static/media/landmark.94eb2797.svg";